import React from "react";

import PropTypes from "prop-types";

import styles from "./styles.css";

const ExpandIcon = ({ isExpanded, onClick }) => (
	<div className={styles.expandIcon} onClick={onClick}  data-testid="toggle">
		{isExpanded && <div><i className="fa fa-caret-down" aria-hidden="true" /></div>}
		{!isExpanded && <div><i className="fa fa-caret-right" aria-hidden="true" /></div>}
	</div>
);

ExpandIcon.propTypes = {
	isExpanded: PropTypes.bool,
	onClick: PropTypes.func,
};

export default ExpandIcon;
